// extracted by mini-css-extract-plugin
module.exports = {"bmFile":"CustomFile_bmFile__3w67m","fileSelected":"CustomFile_fileSelected__3GPGy"};